import React, { Component } from 'react';
import Script from 'react-load-script';

import {
    FormGroup,
    InputGroup,
    Button,
    ButtonToolbar,
    ControlLabel,
    FormControl,
    HelpBlock,
} from 'react-bootstrap';


class BookingPlaceSearch extends Component {

    constructor(props) {
        super(props)
        this.handleScriptLoad = this.handleScriptLoad.bind(this);
        this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
    }


    handleScriptLoad() {
        // Declare Options For Autocomplete

        // Initialize Google Autocomplete
        /*global google*/ // To disable any eslint 'google not defined' errors
        this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'));

        // Fire Event when a suggested name is selected
        this.autocomplete.addListener('place_changed', this.handlePlaceSelect);
    }

    handlePlaceSelect() {
        // Extract City From Address Object
        let addressObject = this.autocomplete.getPlace();
        this.props.handlePlaceSelect(addressObject);        
    }

    render() {

        const { input, label, meta } = this.props
        return (
            <div>
                <Script
                    url="https://maps.googleapis.com/maps/api/js?key=AIzaSyC_dfJjkQ_rwR1TLJ1ZKWUZcttrzDypBJ0&libraries=places"
                    onLoad={this.handleScriptLoad}
                />
                <InputGroup>
                    {label && <ControlLabel>{label}</ControlLabel>}
                    <FormControl
                        type="text"
                        id="autocomplete"
                        {...input}
                        value={this.props.place}
                        onChange={this.props.placeTextBoxChange}
                    />
                    {meta.touched &&
                        ((meta.error && <p className="alert alert-danger">{meta.error}</p>) ||
                            (meta.warning && <p className="alert alert-warning">{meta.warning}</p>))}
                </InputGroup>
            </div>
        );
    }


}

export default BookingPlaceSearch;


// WEBPACK FOOTER //
// src/routes/tours/components/BookingPlaceSearch.js